<template>
    <v-container fluid ma-0 pa-0 px-4>
      <div class="fixed-header" :class="{'mobile': $vuetify.breakpoint.smAndDown}"><!-- if has summary fields add class 'with-summary' -->
        <v-layout  align-center fill-height class="fixed-header-wrapper">
          <v-flex shrink class="text-truncate" pr-4>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <h2 v-on="on" class="p-relative text-truncate" >
                  Teams
                </h2>
              </template>
                <span>Teams</span>
              </v-tooltip>
            <h4 class="pt-1 sub-header ">Teams - <span class="font-weight-bold">{{teamCount}}</span></h4>
          </v-flex>
          <v-spacer></v-spacer>
          <v-divider vertical ></v-divider>
          <v-flex shrink fill-height class="action">
            <v-tooltip left color="secondary">
              <v-btn
                icon
                flat
                slot="activator"
                @click="newTeam()"
                >
                <v-icon color="success" size="24">add_circle</v-icon>
                  </v-btn>
                  <span>Create a new Team</span>
                </v-tooltip>
          </v-flex>
        </v-layout>
      </div>
      <v-layout wrap>
        <v-flex xs12 pt-1>
          <v-btn
            :ripple="false" flat class="ml-0 mb-2 search-button"
            v-on:click="searchTeamsToggled = !searchTeamsToggled">
            <v-icon color="secondary" class="mr-2 mt-0">
              {{ searchTeamsToggled ? 'close' : 'search' }}
            </v-icon>
            {{ searchTeamsToggled ? 'Close search' : 'Search' }}
          </v-btn>
          <v-slide-y-transition>
            <v-layout row wrap class="mt-0" v-if="searchTeamsToggled">
              <v-flex xs12 sm6 md4 pt-1 :class="{'pr-0 ': $vuetify.breakpoint.xsAndDown, 'pr-2': $vuetify.breakpoint.smAndUp}">
                <v-text-field
                  box
                  class="cardcontainer-search-text pa-0 ma-0 body-1"
                  v-model="searchTerm"
                  label="Search"
                  clearable
                  color="secondary"
                  clear-icon="cancel">
                  <template slot="append">
                    <v-icon>search</v-icon>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pt-1 :class="{'pl-0': $vuetify.breakpoint.xsAndDown, 'pl-2': $vuetify.breakpoint.smAndUp}">
                <v-select
                  box clearable
                  style="border-bottom:0 !important; "
                  class="cardcontainer-order-select pa-0 ma-0 body-1"
                  :items="orderByOptions"
                  v-model="orderSelection"
                  @change="search()"
                  label="Order by"
                  color="secondary"
                  clear-icon="cancel"
                  append-icon="keyboard_arrow_down">
                </v-select>
              </v-flex>
            </v-layout>
          </v-slide-y-transition>
        </v-flex>
      </v-layout>
       <v-layout row wrap fluid class="card-margin-fix">
          <TeamCard v-for="(team, index) in orderedTeams" :key="index" :cardContent="team"></TeamCard>
      </v-layout>
    </v-container>
</template>

<script>
import "@/assets/styles/styles.css"
import { mapState } from "vuex"
import TeamCard from '@/components/teams/TeamCard.vue'

export default {
  name: "teams",
  components: { TeamCard },
  data: () => ({
    searchTeamsToggled: false,
    orderSelection: undefined,
    orderByOptions: [
      { text: "Date Created", value: "createdAt" },
      { text: "Name", value: "displayName" }
    ],
    searchByOptions: ["displayName", "id"],
    searchTerm: "",
    localTeamList: undefined
  }),
  watch: {
    searchTerm() { this.search() }
  },
  computed: {
    ...mapState({
      teams: state => state.teams.all,
      isLoading: state => state.ui.loadingTeams
    }),
    orderedTeams: {
      get() {
        if (!this.localTeamList) { this.search() }
        return this.localTeamList
      },
      set(newlist) {
        this.localTeamList = newlist
      }
    },
    teamCount() {
      if (this.teams && this.teams.length > 0) {
        return this.teams.length
      } else {
        return 0
      }
    }
  },
  methods: {
    newTeam() {
      this.$router.push("/teams/new")
    },
    search() { // And Sort
      let newList = this.teams

      if (this.searchTerm) {
        newList = this.teams.filter((team) => team.displayName.toLowerCase().includes(this.searchTerm.toLowerCase()))
      }

      if (this.orderSelection) {
        switch (this.orderSelection) {
          case "displayName":
            newList = this.orderByName(newList)
            break
          case "createdAt":
            newList = this.orderByCreation(newList)
            break
          default:
            break
        }
      }
      this.orderedTeams = newList
    },
    orderByName(teams) {
      if (teams && teams.length > 0) {
        return teams.sort(function (a, b) {
          if (a.displayName < b.displayName) { return -1 }
          if (a.displayName > b.displayName) { return 1 }
          return 0
        })
      }
      return []
    },
    orderByCreation(teams) {
      if (teams && teams.length > 0) {
        return teams.sort(function (a, b) {
          if (a.id < b.id) { return -1 }
          if (a.id > b.id) { return 1 }
          return 0
        })
      }
      return []
    }
  }
}
</script>

<style>
.colored-background-team {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  position: absolute;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  z-index: 0;
}

.colored-background-team-two {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  position: absolute;
  width: 50px;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0;
}
</style>
